<template>
  <div id="header-container">
    <table :id="tableid" class="small-text">
      <tbody>
        <tr>
          <td><img v-if="organization.logo" id="logo-small" :src="base64Logo"></td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td class="font-weight-bold">{{ $t('reports.creation_time') }}:</td>
          <td>{{ new Date().toJSON().slice(0,10).split('-').reverse().join('/') }}</td>
        </tr>
        <tr>
          <td>{{ organization.name }}</td>
          <td/>
          <td class="font-weight-bold">{{ (fullHeader || showRecipient) ? $t('recipient') + ':' : '' }}</td>
          <td>{{ (fullHeader || showRecipient) ? recipient.first_name + ' ' + recipient.last_name : '' }}</td>
        </tr>
        <tr>
          <td>{{ organization.email }}</td>
          <td/>
          <td class="font-weight-bold"><span v-if="abilitySnapshot && fullHeader">{{ fullHeader ? $t('reports.abilities_evaluation') + ':' : '' }}</span></td>
          <td>{{ abilitySnapshot && fullHeader ? abilitySnapshot.title : '' }}</td>
        </tr>
        <tr>
          <td>{{ organization.phone }}</td>
          <td/>
          <td class="font-weight-bold"><span v-if="abilitySnapshot && fullHeader">{{ fullHeader ? $t('reports.last_updated') + ':' : '' }}</span></td>
          <td>{{ abilitySnapshot && fullHeader ? formatDate(abilitySnapshot.updated_at) : '' }}</td>
        </tr>
        <tr>
          <td/>
          <td/>
          <td class="font-weight-bold"><span v-if="requirementSnapshot && fullHeader">{{ fullHeader ? $t('reports.requirements_profile') + ':' : '' }}</span></td>
          <td>{{ requirementSnapshot && fullHeader ? requirementSnapshot.title : '' }}</td>
        </tr>
        <tr>
          <td>{{ user.first_name + ' ' + user.last_name }}</td>
          <td/>
          <td class="font-weight-bold"><span v-if="requirementSnapshot && fullHeader">{{ fullHeader ? $t('reports.last_updated') + ':' : '' }}</span></td>
          <td>{{ requirementSnapshot && fullHeader ? formatDate(requirementSnapshot.updated_at) : '' }}</td>
        </tr>
        <tr>
          <td>{{ user.email }}</td>
          <td/>
          <td class="font-weight-bold"><span v-if="perceptionSnapshot && fullHeader">{{ $t('reports.perception_evaluation') + ':' }}</span></td>
          <td><span v-if="perceptionSnapshot && fullHeader">{{ perceptionSnapshot.title }}</span></td>
        </tr>
        <tr>
          <td>{{ user.phone }}</td>
          <td/>
          <td class="font-weight-bold"><span v-if="perceptionSnapshot && fullHeader">{{ $t('reports.last_updated') + ':' }}</span></td>
          <td><span v-if="perceptionSnapshot && fullHeader">{{ formatDate(perceptionSnapshot.updated_at) }}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ReportHeader',

  props: {
    organization: { type: Object, required: true },
    user: { type: Object, required: true },
    recipient: { type: Object, required: true },
    abilitySnapshot: { type: Object },
    requirementSnapshot: { type: Object },
    perceptionSnapshot: { type: Object, required: false },
    tableid: { type: String, required: true },
    fullHeader: { type: Boolean, default: true },
    showRecipient: { type: Boolean, default: false }
  },

  data: () => ({
    encodedImg: null
  }),

  computed: {
    hostname () {
      var getUrl = window.location
      var baseUrl = getUrl.protocol + '//' + getUrl.host
      return baseUrl
    },

    base64Logo () {
      if (this.organization.logo) {
        if (this.encodedImg) {
          return this.encodedImg
        }

        axios.get(this.hostname + this.organization.logo, {
          responseType: 'arraybuffer'
        }).then((response) => {
          let image = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
          this.encodedImg = `data:${response.headers['content-type'].toLowerCase()};base64,${image}`
        })
      }
      return '#'
    }
  },

  methods: {
    formatDate (date) {
      if (date) {
        return date.slice(0, 10).split('-').reverse().join('/')
      }

      return ''
    }
  }

}
</script>

<style scoped>
/*#header-container {
  width: auto;
  margin-bottom: 10px;
}

#header-container table tr td {
  white-space: nowrap;
}*/

#logo-small {
  max-width: 3cm;
  width: auto;
  height: auto;
}

.spacer{
  width: 20%;
}

.small-text {
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/ReportHeader.vue